// 图像编辑相关翻译

export const editing = {
    // 图像编辑面板
    imageEditingPanel: 'Image Editing Panel',
    uploadImage: 'Upload Image',
    uploadImageDescription: 'Upload an image to start editing',
    dragDropImage: 'Drag and drop an image here, or click to select',
    dragOrClickUpload: 'Drag and drop an image here, or click to select',
    supportedFormats: 'Supported formats: JPG, PNG, WebP',
    maxFileSize: 'Max file size: 10MB ({{remaining}} slots remaining)',
    uploadedImages: 'Uploaded Images ({{count}})',
    fileRejectedError: 'File rejected. Please check format and size.',
    slotsRemainingError: 'Only {slots} slots remaining',
    uploadImageFirst: 'Please upload an image first',
    
    // 编辑功能
    conversationalEditing: 'Conversational Editing',
    conversationalEditingDescription: 'Describe the changes you want to make',
    conversationalEditingFeature: 'Natural language editing commands',
    multiImageReference: 'Multi-image reference support',
    intelligentUnderstanding: 'Intelligent understanding of editing intent',
    
    // AI图像编辑
    aiImageEditing: 'AI Image Editing',
    quickStyles: 'Quick Styles',
    quickStyleOptions: {
      enhancedetails: 'Enhance Details',
      artstyle: 'Art Style', 
      animestyle: 'Anime Style',
      realisticphoto: 'Realistic Photo'
    },
    describeEffect: 'Describe the effect you want',
    describeEffectPlaceholder: 'e.g., Make it look like an oil painting, add dramatic lighting, change to anime style...',
    
    // 样式提示
    stylePrompts: {
      enhanceDetails: 'Enhance image details and sharpness',
      artStyle: 'Transform into artistic style',
      animeStyle: 'Convert to anime/manga style',
      realisticPhoto: 'Make it look like a realistic photograph'
    },
    
    // 编辑错误处理
    editingGeneralError: 'Image editing failed',
    editingRateLimitError: 'Rate limit exceeded for editing',
    editingInsufficientCreditsError: 'Insufficient credits for editing',
    editingNetworkError: 'Network error during editing',
    imageEditingTimeout: 'Image editing timed out',
    checkEditingStatusFailed: 'Failed to check editing status',
    
    // 编辑操作
    editingOptions: 'Editing Options',
    styleTransfer: 'Style Transfer',
    enhancement: 'Enhancement',
    filters: 'Filters',
    adjustments: 'Adjustments',
    
    // 样式转换
    selectStyle: 'Select Style',
    applyStyle: 'Apply Style',
    styleStrength: 'Style Strength',
    preserveDetails: 'Preserve Details',
    
    // 增强选项
    enhanceQuality: 'Enhance Quality',
    upscale: 'Upscale',
    denoising: 'Denoising',
    sharpening: 'Sharpening',
    
    // 滤镜
    vintage: 'Vintage',
    blackWhite: 'Black & White',
    sepia: 'Sepia',
    vibrant: 'Vibrant',
    cool: 'Cool',
    warm: 'Warm',
    
    // 调整
    brightness: 'Brightness',
    contrast: 'Contrast',
    saturation: 'Saturation',
    hue: 'Hue',
    
    // 操作按钮
    reset: 'Reset',
    apply: 'Apply',
    save: 'Save',
    processing: 'Processing...',
    
    // 错误和状态
    uploadError: 'Upload failed, please try again',
    processingError: 'Processing failed, please try again',
    imageProcessed: 'Image processed successfully',
    
    // 图像到图像
    imageToImageGeneration: 'Image-to-Image Generation',
    referenceImage: 'Reference Image',
    generationPrompt: 'Generation Prompt',
    strength: 'Strength',
    strengthDescription: 'How much the AI should modify the original image',
    
    // 文本到图像面板
    textToImagePanel: 'Text-to-Image Panel',
    generateFromText: 'Generate from Text',
    textPrompt: 'Text Prompt',
    negativePrompt: 'Negative Prompt',
    negativePromptPlaceholder: 'What you don\'t want to see in the image...',
    
    // 高级设置
    advancedSettings: 'Advanced Settings',
    seed: 'Seed',
    steps: 'Steps',
    guidanceScale: 'Guidance Scale',
    sampler: 'Sampler'
  };
